import { defineStore } from 'pinia';

import { RouterEnum, GridEnum } from '@interface/public';

export interface PublicStateInterface { // 平台状态
  width: number; // 宽
  height: number; // 高
  grid: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'; // 栅格
  scroll: { // 滚动
    x: 0, // X坐标
    y: 0, // Y坐标
    dX: 'left' | 'right', // 方向-X
    dY: 'top' | 'bottom' // 方向-Y
  };
  router: RouterEnum; // 路由
}

/**
 * 公共数据
 */
export default defineStore('public', {
  state: (): PublicStateInterface => { // 状态
    return {
      width: innerWidth,
      height: innerHeight,
      grid: 'xs',
      scroll: {
        x: 0,
        y: 0,
        dX: 'left',
        dY: 'top'
      },
      router: $Config.Template.default
    };
  },
  getters: { // 获取
    /**
     * 判断栅格是否符合条件
     * @return {Function} 回调
     */
    isGridMatch(): Function {
      return (match: string, grid: GridEnum) => {
        let isMatch = false;
        
        switch (match) {
          case '=':
            isMatch = this.width === grid;
            break;
          case '>':
            isMatch = this.width > grid;
            break;
          case '>=':
            isMatch = this.width >= grid;
            break;
          case '<':
            isMatch = this.width < grid;
            break;
          case '<=':
            isMatch = this.width <= grid;
            break;
        }
        
        return isMatch;
      };
    }
  },
  actions: { // 方法
    /**
     * 更新栅格
     */
    updateGrid(): void {
      let grid = 'xs';
      
      switch (true) {
        case this.width < $Enum.GridEnum.XS:
          grid = 'xs';
          break;
        case this.width >= $Enum.GridEnum.SM && this.width < $Enum.GridEnum.MD:
          grid = 'sm';
          break;
        case this.width >= $Enum.GridEnum.MD && this.width < $Enum.GridEnum.LG:
          grid = 'md';
          break;
        case this.width >= $Enum.GridEnum.LG && this.width < $Enum.GridEnum.XL:
          grid = 'lg';
          break;
        case this.width >= $Enum.GridEnum.XL && this.width < $Enum.GridEnum.XXL:
          grid = 'xl';
          break;
        case this.width >= $Enum.GridEnum.XXL && this.width < $Enum.GridEnum.XXXL:
          grid = 'xxl';
          break;
        case this.width >= $Enum.GridEnum.XXXL:
          grid = 'xxxl';
          break;
      }
      
      this.grid = grid;
    },
    
    /**
     * 更新滚动
     */
    updateScroll(x: number, y: number): void {
      this.scroll.dX = this.scroll.x >= x ? 'left' : 'right';
      this.scroll.dY = this.scroll.y >= y ? 'top' : 'bottom';
      this.scroll.x = x;
      this.scroll.y = y;
    }
  }
});